// Module
var code = "<div class=\"tooltipContent\" data-bind=\"css: cssClass\">\n    <component-loading data-bind=\"visible: !text()\"></component-loading>\n    <div data-bind=\"html: text, visible: text\"></div>\n</div>";
// Exports
module.exports = code;